export default "__VITE_ASSET__KxErfWud__"